import * as React from 'react';
import { FC, useEffect, useState } from 'react';
import { Button } from 'reactstrap';


interface IScrollToTopProps  {
    showBelow?: number
}
const ScrollToTopArrow: FC<IScrollToTopProps> = ({ showBelow = 400 }) => {
    const [showScroll, setShowScroll] = useState<boolean>(false)
    useEffect(() => {
        window.addEventListener('scroll', checkScrollTop)
        return () => {
            window.removeEventListener('scroll', checkScrollTop)
        }
    })
    const checkScrollTop = () => {
        if (!showScroll && window.pageYOffset > showBelow) {
            setShowScroll(true)
        } else if (showScroll && window.pageYOffset <= showBelow) {
            setShowScroll(false)
        }
    }

    const scrollTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }
    return (
        <Button className="scrollTop" onClick={scrollTop} style={{height: 40, display: showScroll ? 'block' : 'none'}}>Go to top <i className="fa fa-arrow-up fa-fw" aria-hidden="true"/></Button>
    )
}

export { ScrollToTopArrow };



// WEBPACK FOOTER //
// ./src/components/shared/ScrollToTopArrow.tsx